import { TAdFoxBannerCompleteSizes } from '@cian/adfox-component';
import { type TTgbNativedescGeneralContext } from '@cian/adfox-templates';
import { IBannerEnrichments } from 'shared/repositories/ad-banner/entities/get_banner_enrichments_v1/BannerEnrichments';
import { IAddressInfo } from 'shared/types/geo/address';
import { getTransportTypeFromRegionId } from 'shared/utils/getTransportTypeFromRegionId';

import type { TTgbNativedescGeneralWideProps } from '../components/TgbNativedescGeneralWide';

type TGetTgbNativedescGeneralWidePropsParams = {
  address: IAddressInfo[];
  context: TTgbNativedescGeneralContext;
  sizes: TAdFoxBannerCompleteSizes;
  bannerEnrichment: null | IBannerEnrichments;
};

export function getTgbNativedescGeneralWideProps({
  address,
  context: {
    url,
    label,
    image,
    title,
    annotation,
    description,
    logoImageUrl,
    builderName,
    metro,
    metroColor,
    metroDistance,
    button,
    location,
    mortgageTermsWarning,
    mortgageWarning,
  },
  sizes,
  bannerEnrichment,
}: TGetTgbNativedescGeneralWidePropsParams): TTgbNativedescGeneralWideProps {
  const transports: TTgbNativedescGeneralWideProps['transports'] = [];

  if (metro) {
    const iconType = address[0]?.id ? getTransportTypeFromRegionId(address[0].id) : null;

    transports.push({
      iconColor: metroColor,
      iconType,
      id: 1,
      name: metro,
      remoteness: metroDistance,
    });
  }

  const tgbNativedescGeneralWideProps: TTgbNativedescGeneralWideProps = {
    logoImageUrl,
    url,
    transports,
    label,
    button,
    image,
    annotation,
    builderName,
    title,
    address: location,
    description,
    mortgageTermsWarning,
    mortgageWarning,
    sizes,
  };

  if (bannerEnrichment) {
    Object.assign<TTgbNativedescGeneralWideProps, Partial<TTgbNativedescGeneralWideProps>>(
      tgbNativedescGeneralWideProps,
      {
        address: bannerEnrichment.address,
        builderName: bannerEnrichment.publisher.name,
        logoImageUrl: bannerEnrichment.publisher.logo.url,
        transports: bannerEnrichment.transports,
      },
    );
  }

  return tgbNativedescGeneralWideProps;
}
